import { DataLoadError } from "components/ui/DataLoadError";
import { useAllergies } from "features/patients/hooks/useAllergies";
import { useCurrentPatientId } from "features/patients/hooks/useCurrentPatientId";

import styles from "../../PatientOverviewModal.module.css";
import { Table } from "./Table/Table";

export const Allergies = () => {
  const patientId = useCurrentPatientId();
  const {
    data: all,
    isPending: isLoading,
    isError,
    isFetching,
    refetch,
  } = useAllergies(patientId);

  const [allergies, intolerances] = (all || []).reduce(
    (acc, item) => {
      if (item.allergyType === "ALLERGY") {
        item.drugAllergyVal = item.drugAllergy ? "Yes" : "-";
        item.seriousVal = item.serious ? "Yes" : "-";
        acc[0].push(item);
      } else {
        acc[1].push(item);
      }
      return acc;
    },
    [[], []]
  );

  const columns = [
    { header: "Name", field: "name" },
    { header: "Symptoms", field: "allergyReaction" },
    { header: "Drug allergy", field: "drugAllergyVal" },
    { header: "Serious", field: "seriousVal" },
  ];

  // Empty allergy and intolerance tables would read as "none recorded"
  // (KIN-1614) — the failure has to replace them, not sit beside them.
  if (isError) {
    return (
      <DataLoadError
        label="this patient's allergies"
        text="This is not a statement that the patient has none. Check the allergy record before prescribing."
        onRetry={refetch}
        isRetrying={isFetching}
      />
    );
  }

  return (
    <div>
      <h3 className={styles.tableTitle}>Allergies</h3>
      <Table
        columns={columns}
        items={allergies || []}
        tableName="allergies-allergies"
        isLoading={isLoading}
      />
      <h3 className={styles.tableTitle}>Intolerance</h3>
      <Table
        items={intolerances || []}
        tableName="allergies-intolerance"
        isLoading={isLoading}
      />
    </div>
  );
};
